(function () {
    UX.purchasePopup = {
        selector: {
            body: 'body',
            purchasePopup: '.purchase-options-popup',
            popupTrigger: '.show-purchaseOptions',
            closePopup: '.purchase-options-popup .close',
        },
        init: function () {
            const isExist = false;
            this.set(isExist);
            this.accessibility.init();
            this.controls(isExist);
        },
        accessibility: {
            init: function () {
                this.accElements = document.querySelectorAll('main.content, .footer, .header');
            },
            show: function () {
                this.accElements.forEach(item => {
                    item.setAttribute('aria-hidden', true);
                });
            },
            hide: function () {
                this.accElements.forEach(item => {
                    item.removeAttribute('aria-hidden');
                });
            },
        },
        set: function (isExist) {
            this.trigger = document.querySelector(this.selector.popupTrigger);
            this.body = document.querySelector(this.selector.body);
            if (isExist) {
                this.popup = document.querySelector(this.selector.purchasePopup);
                this.close = document.querySelector(this.selector.closePopup);
            }
        },
        controls: function (isExist) {
            this.trigger.addEventListener('click', e => {
                e.preventDefault();
                this.ajaxUrl = e.target.href;
                if (!this.popup) {
                    this.ajaxRequest()
                        .then(data => {
                            document.querySelector('body').insertAdjacentHTML('beforeend', data);
                            this.set(true);
                            this.controls(true);
                        })
                        .catch(error => {
                            throw error;
                        });
                } else {
                    this.popup.classList.remove('hidden');
                    this.body.classList.add('noscroll');
                    this.body.setAttribute('data-active', 'model');
                    this.accessibility.show();
                }
            });
            if (isExist) {
                this.close.addEventListener('click', e => {
                    this.popup.classList.add('hidden');
                    this.body.classList.remove('noscroll');
                    this.body.removeAttribute('data-active');
                    this.accessibility.hide();
                    e.preventDefault();
                });
            }
        },
        ajaxRequest: function () {
            return new Promise((resolve, reject) => {
                let request = new XMLHttpRequest();
                request.open('get', this.ajaxUrl + '&ajaxRequest=true');
                request.onreadystatechange = function () {
                    if (this.readyState === 4) {
                        if (this.status === 200) {
                            resolve(this.responseText);
                        } else {
                            reject(this.statusText);
                        }
                    }
                };
                request.send();
            });
        },
    };
})();
